import Config from '@/config';
import wx from 'weixin-jsapi';
import {Dialog, Toast} from 'vant';
import {mapActions, mapGetters} from 'vuex';
import {getToken, inAppBrowser, loadScript} from '@/libs/util';
import {getJsApiConfigParams, me, myOrders, scanQRCodeCharge, scanQRCode} from '@/api';

export default {
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },
    data() {
        return {
            client: inAppBrowser(),
            isLoadAlipaySdk: false,

            chargingOrder: null,
            chargingOrderLastRequestTime: 0,

            qrContent: null,
            showActionSheet: false,
            payToChargeMoney: null
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'charging'
        ]),
        isManager() {
            return this.user && this.user.isManager;
        }
    },
    methods: {
        ...mapActions([
            'setUser',
            'setCharging'
        ]),
        wxPaySan() {
            const toast = Toast.loading({
                forbidClick: true,
            });

            getJsApiConfigParams(location.href).then(response => {
                if (response.data.code === Config.successCode) {
                    wx.config({
                        debug: false,
                        appId: response.data.body.appId,
                        nonceStr: response.data.body.nonceStr,
                        timestamp: response.data.body.timestamp,
                        signature: response.data.body.signature,
                        jsApiList: ['checkJsApi', 'scanQRCode']
                    });

                    wx.error((res) => {
                        toast.clear();
                        console.error(res);
                        this.$router.push({name: 'scanQr'});
                    });

                    wx.ready(() => {
                        wx.checkJsApi({
                            jsApiList: ['scanQRCode'],
                            success: () => {
                                toast.clear();
                                wx.scanQRCode({
                                    needResult: 1,
                                    scanType: ['qrCode'],
                                    success: (res) => {
                                        this.scanRs(res.resultStr);
                                    }
                                });
                            }
                        });
                    });
                } else {
                    toast.clear();
                    this.$router.push({name: 'scanQr'});
                }
            }).catch((error) => {
                toast.clear();
                this.$router.push({name: 'scanQr'});
            });
        },
        alipaySan() {
            if (!this.isLoadAlipaySdk) {
                const toast = Toast.loading({
                    forbidClick: true,
                });
                loadScript(['https://gw.alipayobjects.com/as/g/h5-lib/alipayjsapi/3.1.1/alipayjsapi.min.js']).then(() => {
                    ap.scan((res) => {
                        this.scanRs(res.code);
                    });
                    this.isLoadAlipaySdk = true;
                }).catch(error => {
                    toast.clear();
                    this.$router.push({name: 'scanQr'});
                });
            } else {
                ap.scan((res) => {
                    this.scanRs(res.code);
                });
            }
        },
        scanRs(qrContent) {
            if (!this.isLogin()) {
                this.$router.push('login');
                return;
            }

            if (qrContent.startsWith('coupon://')) {
                Dialog.confirm({
                    title: '提示',
                    message: '是否核销兑换券：' + qrContent.replace(/[^0-9]/ig, '')
                }).then(() => this.scanRequest(qrContent));
            } else {
                let gunCode = qrContent.match(/[0-9]{19}/);
                if (!gunCode) {
                    Toast.fail('不支持的二维码');
                    return;
                }

                this.qrContent = qrContent;
                if (this.user && this.user.amount >= 10) {
                    scanQRCode(qrContent).then(this.scanRequestCallback);
                } else {
                    this.showActionSheet = true;
                }
            }
        },
        scan() {
            if (this.client === 'wx') {
                this.wxPaySan();
                return;
            } else if (this.client === 'alipay') {
                this.alipaySan();
                return;
            }

            this.$router.push({name: 'scanQr'});
        },
        inputMoneyConfirm() {
            if (!this.payToChargeMoney) {
                Toast.fail('金额不能为空');
                return;
            } else {
                // WXPay.jsPay trade.jsPay acp.jsPay
                let subPlatform;
                if (this.client === 'wx') {
                    subPlatform = 'WXPay.jsPay';
                } else if (this.client === 'alipay') {
                    subPlatform = 'trade.jsPay';
                } else {
                    subPlatform = 'acp.jsPay';
                }
                scanQRCodeCharge(this.payToChargeMoney, this.qrContent, subPlatform).then(response => {
                    if (response.data.code === Config.successCode) {
                        window.open(response.data.body, '_blank');
                    }
                }).finally(() => {
                    this.showActionSheet = false;
                    this.payToChargeMoney = null;
                });
            }
        },
        scanRequestCallback(response) {
            if (response.data.code === '100022') {
                this.$router.push({name: 'recharge'});
            }

            if (response.data.code === '000000') {
                if (response.data.body.type === 'charge') {
                    this.toCharge(response.data.body.gunCode, response.data.body.sn);
                } else {
                    Toast.success(response.data.body.tip);
                }
            }
        },
        scanRequest(qrContent) {
            scanQRCode(qrContent).then(this.scanRequestCallback);
        },
        toCharge(gunCode, sn) {
            this.$router.push({name: 'charge', params: {gunCode, sn}});
        },
        navigation(from, to) {
            window.location.href = 'http://uri.amap.com/navigation?from=' + from.longitude + ',' + from.latitude
                + '&to=' + to.longitude + ',' + to.latitude + '&mode=car&src=nyx_super;';
        },
        isLogin() {
            return Boolean(getToken());
        },
        loadMyInfo() {
            if (this.isLogin() && !this.user) {
                this.me();
            }
        },
        refreshMyInfo(callback) {
            if (getToken()) {
                this.me(callback);
            } else {
                callback && callback();
            }
        },
        me(callback) {
            me().then(response => {
                if (response.data.code === Config.successCode) {
                    this.setUser(response.data.body);
                }
            }).finally(() => {
                callback && callback();
            });
        },
        getChargingOrder() {
            if (new Date().getTime() - this.chargingOrderLastRequestTime < 5000) {
                return;
            }

            if (getToken()) {
                myOrders('', 4, 1, 1).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.chargingOrderLastRequestTime = new Date().getTime();
                        this.chargingOrder = response.data.body.total > 0 ? response.data.body.data[0] : null;
                    }
                });
            }
        }
    }
}
